export enum EPayementStatus {
	required = "required",
	completed = "completed",
}
